import type { IModule, ModuleContext } from '@punica/editor';
import { ModuleLifecycleState } from '@punica/editor';
import { MODULE_NAMES } from '@punica/editor';

/**
 * Shell PanelLayout module — loads persisted bottom-panel preferences into the
 * `punica.shell.PanelLayout` store during `start()`, so the synchronous getters
 * are populated before extensions load (extension load creates the tabs that
 * consult the store). Depends on kernel.commands only for lifecycle ordering;
 * the settings manager is reached lazily via the `punica` global.
 */
export class PanelLayoutModule implements IModule {
  readonly name = MODULE_NAMES.SHELL.PANEL_LAYOUT;
  readonly version = '1.0.0';
  readonly dependencies: readonly string[] = [MODULE_NAMES.KERNEL.COMMANDS];

  #state: ModuleLifecycleState = ModuleLifecycleState.CREATED;

  get state(): ModuleLifecycleState {
    return this.#state;
  }

  async bootstrap(context: ModuleContext): Promise<void> {
    const { punica } = context;
    if (!punica.shell?.PanelLayout?.manager) {
      throw new Error('PanelLayout API not available');
    }
  }

  async start(context: ModuleContext): Promise<void> {
    // Populate the store from settings (+ active profile defaults). Idempotent;
    // failures degrade to substrate defaults rather than blocking start.
    try {
      await context.punica.shell.PanelLayout.manager.load();
    } catch (err) {
      // eslint-disable-next-line no-console
      console.warn('[PanelLayout] load during start failed', err);
    }
  }
}
